import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { CompletedIcon } from '~/assets/icons'

export type CircledTextProps = {
  text?: string,
  textStyle?: any,
  textColor?: string,
  disabled?: boolean,
  finished?: boolean,
  circleText: string,
  containerStyle?: any,
  circleColor?: string,
  circleTextStyle?: any,
  circleTextColor?: string,
  circleWidth?: number | string
}

const getColor = (props: CircledTextProps, color?: string, isBorder?: boolean) => {
  if (props.finished) {
    return isBorder
      ? ''
      : mutualTheme.palette.textGray3.main
  }
  if (props.disabled) {
    return isBorder
      ? mutualTheme.palette.textGray4.main
      : mutualTheme.palette.textGray3.main
  }
  return color || mutualTheme.palette.blue.main
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  circleText: (props: CircledTextProps) => ({
    ...props.circleTextStyle,
    fontWeight: 700,
    color: getColor(props, props.circleTextColor)
  }),
  circleView: (props: CircledTextProps) => ({
    display: 'flex',
    width: 24,
    height: 24,
    borderRadius: 50,
    alignItems: 'center',
    borderStyle: 'solid',
    justifyContent: 'center',
    padding: mutualTheme.spacing(1),
    borderWidth: props.circleWidth || 2,
    borderColor: getColor(props, props.circleColor, true)
  }),
  text: (props: CircledTextProps) => ({
    ...props.textStyle,
    fontWeight: 700,
    marginLeft: mutualTheme.spacing(2),
    color: getColor(props, props.textColor)
  })
})

export const CircledText: React.FC<CircledTextProps> = (props) => {
  const { circleText, text } = props
  const classes = useStyles(props)

  return (
    <Box className={`${classes.container} ${props.containerStyle}`}>
      {!props.finished
        ? (
          <Box className={classes.circleView}>
            <Typography className={classes.circleText}>
              {circleText}
            </Typography>
          </Box>
        )
        : <CompletedIcon />
      }
      {text && (
        <Typography className={classes.text}>
          {text}
        </Typography>
      )}
    </Box>
  )
}
